import { msg } from "@lit/localize";
import { createAsyncActionGroup } from "@progressive-development/pd-spa-helper";

import type { WahlErgebnis } from "../service/wahlen-service.js";

/**
 * Der eine Ladevorgang des Kapitels Wahlen: eine Ergebnis-Sicht.
 *
 * Die Nutzlast ist die Dokument-ID `{teilwahlId}:{gebietId}` — gebildet aus
 * den Verzeichnissen (`sichtId` in `wahl-auswahl.ts`), nie aus der Adresse
 * zusammengeschnitten. Übersicht und Gebietsblöcke brauchen keinen eigenen
 * Ladevorgang; sie lesen aus den Verzeichnissen des Startseiten-Stores.
 *
 * Registriert in `common/store/app-loading-effects.ts` (backgroundGroups).
 */
export const loadWahlErgebnis = createAsyncActionGroup<string, WahlErgebnis>("LOAD_WAHL_ERGEBNIS", {
  loadingTxt: msg("Wahlergebnis wird geladen…", { id: "app.wahl.ergebnis.loading.toast" }),
  smallBackground: true,
});
